import { Button } from '@ace-clublabs/shared-component-library';

interface TimeSlotProps {
  label: string;
  onClickHandler: () => void;
  isSelected: boolean;
  testId?: string;
  disabled?: boolean;
}

const TimeSlot = ({
  label,
  onClickHandler,
  isSelected,
  testId,
  disabled = false,
}: TimeSlotProps) => {
  return (
    <Button
      aria-selected={isSelected}
      label={label}
      variant={'outlined'}
      onClick={onClickHandler}
      data-testid={`timeButton-${testId}`}
      disabled={disabled}
      sx={[
        {
          width: '99%',
          minHeight: '60px',
          fontSize: '20px',
          backgroundColor: 'white',
          color: 'primary.600',
          '&:hover': {
            backgroundColor: 'primary.100',
          },
        },
        isSelected && {
          backgroundColor: 'primary.600',
          color: 'white',
          '&:hover': {
            backgroundColor: 'primary.600',
          },
        },
      ]}
    />
  );
};

export default TimeSlot;
